import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const Badge = styled.span`
  color: ${themeStyles.colors.white.main};
  font-size: 0.6em;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  text-align: center;
  background-color: ${themeStyles.colors.lightGreys[2].main};
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) =>
    theme === 'blue' &&
    css`
      background-color: ${themeStyles.colors.products.sports.main};
    `}

  ${({ theme }) =>
    theme === 'green' &&
    css`
      background-color: ${themeStyles.colors.defaultColors.green[250]};
    `}
`
